/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Directory_Vibebids_Minimum_BidInputs */

const en_directory_vibebids_minimum_bid = /** @type {(inputs: Directory_Vibebids_Minimum_BidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Minimum bid: $${i?.amount}`)
};

const zh_directory_vibebids_minimum_bid = /** @type {(inputs: Directory_Vibebids_Minimum_BidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最低出价：$${i?.amount} 美元`)
};

/**
* | output |
* | --- |
* | "Minimum bid: ${amount}" |
*
* @param {Directory_Vibebids_Minimum_BidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_minimum_bid = /** @type {((inputs: Directory_Vibebids_Minimum_BidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Minimum_BidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_minimum_bid(inputs)
	return zh_directory_vibebids_minimum_bid(inputs)
});
export { directory_vibebids_minimum_bid as "directory.vibebids.minimum_bid" }